import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BeatYourBrokerRoute } from './beat-your-broker-route/beat-your-broker.route';
import { BeatYourBrokerGuard } from './beat-your-broker.guard';
import { CoverCalculatorRoute } from './cover-calculator-route/cover-calculator.route';

export const routes: Routes = [
    {
        path: 'coverchecker/:page',
        component: BeatYourBrokerRoute,
        canActivate: [BeatYourBrokerGuard]
    },
    { path: 'coverchecker', redirectTo: '/coverchecker/0' },
    { path: '', redirectTo: '/coverchecker', pathMatch: 'full' },
    { path: 'coverCalculator', component: CoverCalculatorRoute }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    providers: [
        BeatYourBrokerGuard
    ],
    exports: [RouterModule]
})
export class ApgBeatYourBrokerRoutingModule { }
